module.exports = __webpack_public_path__ + "static/assets/4da38973d5ffd15c54e80894d430288c.svg";